<template>
  <header class="site-header">
    <a class="header-logo" href="#">
      <div class="logo">
        <img :src="logo_mascot">
      </div>
      <div class="title">
        <span>online</span><span>city.</span><span>io</span>
      </div>
    </a>
    <div class="header-links" :class="{'is-open': mobileMenuOpen}">
      <a class="chat-link" :class="chatLinkClass" href="" @click.prevent="openChat">
        <div class="icon"></div>
        <div class="text">
          Chat
        </div>
        <div class="bg"></div>
      </a>
      <a class="phone-link" href="tel:+4566118311">
        <div class="icon">
          <svg viewBox="0 0 50 50" xml:space="preserve" class="icon-phone" x="0" y="0">
            <path class="icon-path" d="M43.7,33.1l-4.9-4.9c-1-1-2.3-1.5-3.6-1.5c-1.4,0-2.7,0.5-3.6,1.5l-1.3,1.3c-5.1-4.3-10.1-9.2-14.3-14.3
              l1.3-1.3c2-2,2-5.2,0-7.2l-4.9-4.9c-1-1-2.3-1.5-3.6-1.5C7.3,0.2,6,0.7,5,1.7L2.3,4.4c-2.5,2.5-2.9,6.4-0.9,9.4
              c7.9,11.9,18.3,22.3,30.2,30.2c1.2,0.8,2.6,1.2,4.1,1.2c2,0,3.9-0.8,5.3-2.2l2.7-2.7c1-1,1.5-2.3,1.5-3.6
              C45.2,35.3,44.6,34,43.7,33.1z"/>
            </svg>
        </div>
        <div class="text">
          <span>+45</span> 6611 8311
        </div>
        <div class="bg"></div>
      </a>
      <a class="lang-link" :class="{'lang-link-selected':locale==='da'}" href="" @click.prevent="locale = 'da'">
        <div class="icon">
          <svg viewBox="0 0 512 512" xml:space="preserve" height="512" width="512">
            <path fill="#c60c30" d="M0 0h512.1v512H0z"/>
            <path fill="#fff" d="M144 0h73.143v512H144z"/>
            <path fill="#fff" d="M0 219.43h512.1v73.142H0z"/>
          </svg>
        </div>
        <div class="bg"></div>
      </a>
      <a class="lang-link" :class="{'lang-link-selected':locale==='en'}" href="" @click.prevent="locale = 'en'">
        <div class="icon">
          <svg height="512" width="512" viewBox="0 0 512 512">
            <defs>
              <clipPath id="a">
                <path fill-opacity=".67" d="M250 0h500v500H250z"/>
              </clipPath>
            </defs>
            <g clip-path="url(#a)" transform="translate(-256) scale(1.024)">
              <g stroke-width="1pt">
                <path fill="#006" d="M0 0h1000.02v500.01H0z"/>
                <path
                  d="M0 0v55.903l888.218 444.11h111.802V444.11L111.802.003H0zm1000.02 0v55.9L111.802 500.01H0v-55.9L888.218 0h111.802z"
                  fill="#fff"/>
                <path d="M416.675 0v500.01h166.67V0h-166.67zM0 166.67v166.67h1000.02V166.67H0z" fill="#fff"/>
                <path
                  d="M0 200.004v100.002h1000.02V200.004H0zM450.01 0v500.01h100V0h-100zM0 500.01l333.34-166.67h74.535L74.535 500.01H0zM0 0l333.34 166.67h-74.535L0 37.27V0zm592.145 166.67L925.485 0h74.535L666.68 166.67h-74.535zm407.875 333.34L666.68 333.34h74.535l258.805 129.403v37.267z"
                  fill="#c00"/>
              </g>
            </g>
          </svg>
        </div>
        <div class="bg"></div>
      </a>
    </div>
    <button @click="mobileMenuOpen = !mobileMenuOpen" class="hamburger hamburger--boring" :style="menuButtonStyles"
            :class="{'is-active': mobileMenuOpen}" type="button">
      <span class="hamburger-box">
        <span class="hamburger-inner"></span>
      </span>
    </button>
  </header>
</template>

<script>
  import logoMascot from '.././assets/logo-mascot.png';
  import {mapActions} from 'vuex';

  import {detectLocale, changeLocale} from '../multilanguage/locale.js';

  export default {
    name: 'SiteHeader',
    data() {
      return {
        locale: detectLocale(),
        logo_mascot: logoMascot,
        mobileMenuOpen: false
      };
    },
    watch: {
      locale(locale) {
        this.$i18n.locale = locale;
        changeLocale(locale);
        this.$store.dispatch('setLocale', locale);
      },
      mobileMenuOpen(val) {
        if (val) {
          this.setScrollLockedState(true);
        } else {
          this.setScrollLockedState(false);
        }
      }
    },
    computed: {
      chatLinkClass() {
        return this.$store.state.chatOnline ? 'online' : 'offline';
      },
      menuButtonStyles() {
        return this.mobileMenuOpen ? 'z-index: 999' : 'z-index: 100';
      }
    },
    methods: {
      openChat() {
        window.app.openChat();
      },
      ...mapActions([
        'setScrollLockedState'
      ])
    }
  };
</script>

<style lang="scss">
  @import '.././assets/variables';
  .site-header {
    padding: 30px;
    position: absolute;
    width: 100%;
    top: 0;
    z-index: 900;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    @media screen and (max-width: 768px) {
      padding: 20px;
      z-index: 999;
    }
  }
  .close {
    display: block;
    position: absolute;
    top: 32px;
    right: 20px;
    width: 34px;
    height: 34px;
    z-index: 900;
    &:before, &:after {
      content: '';
      position: absolute;
      height: 2px;
      width: 100%;
      top: 50%;
      left: 0;
      margin-top: -1px;
      border-radius: 2px;
      background: #000000;
    }
    &:before {
      transform: rotate(-45deg)
    }
    &:after {
      transform: rotate(45deg)
    }
  }
  .header-logo {
    position: relative;
    display: block;
    color: #082e3c;
    display: flex;
    justify-content: row;
    align-items: center;
    .logo {
      width: 4.6rem;
      margin-right: 1rem;
      @media screen and (max-width: 768px) {
        width: 3rem;
      }
    }
    .title {
      font-family: "Gotham Rounded SSm A", "Gotham Rounded SSm B";
      text-transform: uppercase;
      font-size: 2.25rem;
      @media screen and (max-width: 768px) {
        font-size: 1.25rem;
      }
      span {
        font-weight: 300;
        + span {
          font-weight: 700;
          + span {
            font-weight: 300;
            color: $orange;
          }
        }
      }
    }
  }
  .header-links {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    font-style: normal;
    font-weight: 400;
    a {
      position: relative;
      color: #2c2c2c;
      margin-right: .95rem;
      &:last-of-type {
        margin: 0;
      }
    }
    .close {
      display: none;
      @media screen and (max-width: 768px) {
        display: block;
      }
    }
    @media screen and (max-width: 768px) {
      display: none;
      position: fixed;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 999;
      background-color: rgba(156, 186, 209, 0.95);
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      padding-left: 4rem;
      > a {
        margin-bottom: 2rem;
      }
    }
    &.is-open {
      @media screen and (max-width: 768px) {
        display: flex;
      }
    }
  }
  .bg {
    position: absolute;
    top: 0;
    left: 0;
    background-color: white;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    z-index: -1;
    box-shadow: 0px 0px 3px 0px rgba(156, 186, 209, .8);
    transition: all .14s cubic-bezier(.59, .87, .4, .99);
  }
  .icon {
    width: 30px;
    height: 30px;
    border: 2px solid #082e3c;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-right: .5rem;
    svg {
      width: 58%;
      margin-left: .09rem;
      margin-top: .05rem;
      .icon-path {
        fill: #082e3c;
      }
    }
  }
  .lang-link {
    position: relative;
    transition: all .05s cubic-bezier(.59, .87, .4, .99);
    .icon {
      overflow: hidden;
      border: none;
      margin: 0;
      svg {
        width: 100%;
        margin: 0;
      }
    }
    &.lang-link-selected,
    &:hover {
      transform: scale(1.1);
      .bg {
        transform: scale(1.3);
      }
    }
  }
  a.phone-link,
  a.chat-link {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    .text {
      font-size: 1.125rem;
    }
    .bg {
      background: transparent;
      border: 2px solid #082e3c;
      opacity: 0;
    }
    .icon {
      transition: all .15s cubic-bezier(.59, .87, .4, .99);
    }
    &:hover {
      .icon {
        transform: scale(1.1);
      }
      .bg {
        // opacity: 1;
        // transform: scale(1.4);
      }
    }
  }
  a.chat-link {
    margin-right: 1.2rem;
    .icon {
      margin-right: .6rem;
      width: 34px;
      height: 32px;
      border: none;
      border-radius: 0;
      background-image: url('.././assets/chat-icons.png');
      background-repeat: no-repeat;
      background-size: 100%;
      svg {
        width: 53%;
        margin-top: .065rem;
        margin-left: .0rem;
      }
    }
    &.online {
      .icon {
        background-position: 0 -34px;
      }
    }
    &.offline {
      .icon {
        background-position: 0 -68px;
      }
    }
  }
  .phone-link {
    .text {
      line-height: 1;
      span {
        font-weight: 700;
      }
    }
  }
  @import "~hamburgers/_sass/hamburgers/hamburgers";

  .hamburger:focus {
    outline: none;
  }
  .hamburger {
    -webkit-tap-highlight-color: transparent;
    @media screen and (min-width: 769px) {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SiteHeader.vue